import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBatteryEmpty, faBatteryQuarter, faBatteryHalf, faBatteryThreeQuarters, faBatteryFull, faSolarPanel, faBoltLightning } from "@fortawesome/free-solid-svg-icons";
import api from "../../apis/EdisonApi";
// import EvStatus from "./EvStatus";
import SelfConsumptionStatus from "./SelfConsumptionStatus";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const EnergyStatus = () => {
    const [status, setStatus] = useState('NA');
    
    useEffect(() => {
        const controller = new AbortController();
        getEnergyState();

        return () => {
            controller.abort();
        };
    }, []);

    const getEnergyState = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/aton/status', config);
            //console.log("[Aton] EnergyStatus: ", resp.data.data);

            // Se resp.data.data è null → assegno "NA"
            if (!resp.data || !resp.data.data) {
                setStatus('NA');
            } else {
                setStatus(resp.data.data);
            }
        } catch(err) {
            toast.error("API error getting aton's status");
            setStatus('NA');
        }
    };

    const renderPowerProduction = () => {
        if (status === 'NA') {
            return (
                <span>
                    <Loader size={20} />
                </span>
            );
        } else if (status.powerPV === -1) {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{status.powerPV} W</div>;
        }
         
    };

    const renderPowerConsumption = () => {
        if (status === 'NA') {
            return (
                <span>
                    <Loader size={20} />
                </span>
            );
        }  else {
            return <div className="count">{status.powerConsumed} W</div>;
        }
    };

    const renderBatteryIcon = () => {
        if (status === 'NA') {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryEmpty} /></div>;
        } else if (status.batterySoC > 75) {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryFull} /></div>;
        } else if (status.batterySoC > 50) {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryThreeQuarters} /></div>;
        } else if (status.batterySoC > 25) {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryHalf} /></div>;
        } else if (status.batterySoC > 0) {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryQuarter} /></div>;
        } else {
            return <div className="icon tile-icon--battery"><FontAwesomeIcon icon={faBatteryEmpty} /></div>;
        }
    };

    const renderBatterySoc = () => {

        if (status === 'NA') {
            return (
                <span>
                    <Loader size={20} />
                </span>
            );
        } else {
            return (
                <div id="battery" className="count">
                    {status.batterySoC}%
                </div>
            );
        }
    };

    return (
        <React.Fragment>
        <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="tile-stats">
                <h3>Power production</h3>
                <div className="icon tile-icon--solar"><FontAwesomeIcon icon={faSolarPanel} /></div>
                { renderPowerProduction() }
            </div>
        </div>
        <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="tile-stats">
                <h3>Power consumption</h3>
                <div className="icon tile-icon--consumption"><FontAwesomeIcon icon={faBoltLightning} /></div>
                { renderPowerConsumption() }
            </div>
        </div>
        <div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="tile-stats">
                <h3>Battery</h3>
                { renderBatteryIcon() }
                { renderBatterySoc() }                
            </div>
        </div>        
        <SelfConsumptionStatus />
        {/* <EvStatus /> */}
        </React.Fragment>
    );
};

export default EnergyStatus;
